import { HTMLAttributes } from "react";

export default function MaterialUI(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
    {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.0749512 25.725V5.025L18 15.375V22.275L6.03745 15.375V29.175L0.0749512 25.725ZM18 15.375L35.9625 5.025V25.7625L24 32.625L18 29.175L30 22.275V15.375L18 22.275V15.375Z"
        fill="#1FA6CA"
      />
      <path
        d="M18 29.175V36.075L30 42.975V36.075L18 29.175ZM30 42.975L47.925 32.625V18.825L41.925 22.275V29.175L30 36.075V42.975ZM41.9625 15.375V8.475L47.9625 5.025V11.925L41.9625 15.375Z"
        fill="#1FA6CA"
      />
    </svg>
  )
}
